import { render, staticRenderFns } from "./WorkShopList.vue?vue&type=template&id=7871b2ce&"
import script from "./WorkShopList.vue?vue&type=script&lang=js&"
export * from "./WorkShopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports